<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Reorder Execute Queued Jobs</h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onCancel()"
    title="Close"
  ></i>
</div>
<div class="modal-body text-grey">
  <p *ngIf="jobList?.length > 0" for="">Drag and drop job to change the order of execution.</p>
  <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
    <div *ngIf="jobList?.length > 0; else noContent">
      <div *ngFor="let job of jobList; let i = index">
        <div class="example-box" cdkDrag>
          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
          &nbsp;&nbsp;&nbsp;{{ job.id }}&nbsp;-&nbsp;{{ job.jobName }}
        </div>
      </div>
      <!-- <p><label for="">Note : </label>Changing order multiple times can</p> -->
    </div>
  </div>
  <ng-template #noContent>
    <div class="mt-5 text-center">
      <p>{{ errorMessage }}</p>
    </div>
  </ng-template>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default" zIndex = "1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="queuedJobs"
    ></ngx-spinner
  >
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    cdkFocusInitial
    (click)="onSubmit()"
    [disabled]="isSubmitting"
  >
    Save
  </button>
</div>